<template>
  <div class="p-grid p-m-3">
    <!-- Toolbar -->
    <div class="toolbar-fullwidth p-mb-3">
      <div class="titulo">
        <h3 class="p-m-0">Dashboard</h3>        
      </div>      
      <div class="filtros">
        <span>Período: </span>
        <Calendar v-model="dataInicio" view="month" dateFormat="mm/yy" showIcon placeholder="Mês inicial" />
        <span> - </span>
        <Calendar v-model="dataFim" view="month" dateFormat="mm/yy" showIcon placeholder="Mês final"
          class="p-mr-2" />
        <button class="p-button p-button-sm p-mr-2" @click="filtrarDadosGraficos">
          <i class="pi pi-filter p-mr-1"></i> Filtrar Dados dos Gráficos
        </button>
        <button class="p-button p-button-sm" @click="atualizarTudo">
        <i class="pi pi-refresh p-mr-1"></i> Atualizar Tudo
      </button>
      </div>
    </div>
    <!-- CLIENTES -->
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="card card-clientes">
        <div class="card-header">
          <i class="pi pi-users icon clientes"></i>
          <span>Clientes</span>
        </div>
        <div class="card-body">
          <div class="linha-total">
            <strong>Total:</strong> {{ dados.totalClientes }}
          </div>
          <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
            <span class="badge badge-green p-mr-2">Ativos: {{ dados.totalClientesAtivos }}</span>
            <span class="badge badge-red p-mr-2">Inativos: {{ dados.totalClientesInativos }}</span>
            <span class="badge badge-gray p-mr-2">Bloqueados: {{ dados.totalClientesBloqueados }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- CNPJs -->
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="card card-cnpjs">
        <div class="card-header">
          <i class="pi pi-id-card icon cnpjs"></i>
          <span>CNPJs</span>
        </div>
        <div class="card-body">
          <div class="linha-total">
            <strong>Total:</strong> {{ dados.totalCnpjs }}
          </div>
          <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
            <span class="badge badge-green p-mr-2">Ativos: {{ dados.totalCnpjs }}</span>           
          </div>
        </div>
      </div>
    </div>
    <!-- FUNCIONÁRIOS -->
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="card card-funcionarios">
        <div class="card-header">
          <i class="pi pi-briefcase icon funcionarios"></i>
          <span>Funcionários</span>
        </div>
        <div class="card-body">
          <div class="linha-total">
            <strong>Total:</strong> {{ dados.totalFuncionarios }}
          </div>
          <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
            <span class="badge badge-green p-mr-2">Ativos: {{ dados.totalFuncionariosAtivos }}</span>
            <span class="badge badge-red">Inativos: {{ dados.totalFuncionariosInativos }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Usuários -->
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="card card-usuarios">
        <div class="card-header">
          <i class="pi pi-user icon usuarios"></i>
          <span>Usuários</span>
        </div>
        <div class="card-body">
          <div class="linha-total">
            <strong>Total:</strong> {{ dados.totalUsuarios }}
          </div>
          <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
            <span class="badge badge-green p-mr-2">Ativos: {{ dados.totalUsuarios }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- REVENDEDORES -->
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="card card-revendedores">
        <div class="card-header">
          <i class="pi pi-star icon revendedores"></i>
          <span>Revendedores</span>
        </div>
        <div class="card-body">
          <div class="linha-total">
            <strong>Total:</strong> {{ dados.totalRevendedores }}
          </div>
          <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
            <span class="badge badge-green p-mr-2">Ativos: {{ dados.totalRevendedoresAtivos }}</span>
            <span class="badge badge-red">Inativos: {{ dados.totalRevendedoresInativos }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Revendas -->
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="card card-usuarios p-w100">
        <div class="card-header">
          <i class="pi pi-sitemap icon usuarios"></i>
          <span>Revendas</span>
        </div>
        <div class="card-body">
          <div class="linha-total">
            <strong>Total:</strong> {{ dados.totalRevendas }}
          </div>
          <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
            <span class="badge badge-green p-mr-2">Ativos: {{ dados.totalRevendasAtivas }}</span>
            <span class="badge badge-red">Inativos: {{ dados.totalRevendasInativas }}</span>
          </div>
        </div>
      </div>
    </div>   
    <!--Gráficos -->
    <div class="p-grid">
      <div class="p-col-12 p-md-6 p-lg-4" v-for="(grafico, index) in graficosTotais" :key="index">
        <div class="card">
          <div class="card-header">
            <i :class="grafico.icone + ' icon'"></i>
            <span class="grafico-titulo">{{ grafico.titulo }}
              <span v-if="grafico.variacoes && grafico.variacoes.length > 1" class="variacao">
                <i class="pi" :class="{
                  'pi-arrow-up': grafico.variacoes.slice(-1)[0] > 0,
                  'pi-arrow-down': grafico.variacoes.slice(-1)[0] < 0,
                  'pi-arrow-right': grafico.variacoes.slice(-1)[0] === 0
                }" :style="{ color: corVariação(grafico.variacoes.slice(-1)[0]) }"></i>
                <span :style="{ color: corVariação(grafico.variacoes.slice(-1)[0]) }">
                  {{ grafico.variacoes.slice(-1)[0] > 0 ? '+' : '' }}{{ grafico.variacoes.slice(-1)[0] }}%
                </span>
              </span>
            </span>
          </div>
          <div class="card-body">
            <Chart type="bar" :data="grafico.data" :options="grafico.options" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'primevue/chart';
import EstatisticaAdminService from '@/service/EstatisticaAdminService';
import { exibirMensagem } from '@/global';
export default {
  estatisticaAdminService: null,
  name: 'Dashboard',
  data() {
    return {
      dataInicio: null,
      dataFim: null,
      dados: {},
      graficosTotais: []
    };
  },
  methods: {
    /**
     * 
     */
    atualizarTudo() {
      sessionStorage.removeItem('DADOS_ESTATISTICAS_CLIENTES');
      this.busarAcumulado();
    },
    /**
     * 
     */
    busarAcumulado() {
      const dadosSessao = sessionStorage.getItem('DADOS_ESTATISTICAS_CLIENTES');
      if(dadosSessao) {
        this.dados = JSON.parse(dadosSessao);       
        this.carregarGraficos(this.dados.crescimento);
        return;
      }
      this.estatisticaAdminService.busarAcumulado()
			.then(resp => {
        this.dados = resp.data;
        sessionStorage.setItem('DADOS_ESTATISTICAS_CLIENTES', JSON.stringify(this.dados));
        this.carregarGraficos(this.dados.crescimento);
			})
			.catch(erro => {exibirMensagem(this, erro)});
    },
    /**
     * 
     */ 
    filtrarDadosGraficos() {
      this.estatisticaAdminService.listarPorPeriodo(this.formatarData(this.dataInicio), this.formatarData(this.dataFim))
			.then(resp => {       
        this.carregarGraficos(resp.data);
			})
			.catch(erro => {exibirMensagem(this, erro)});
    },
    /**
     * 
     */
    carregarGraficos(estatisticas) {
      // Labels
      const gerarLabels = (estatisticas) => {
        return estatisticas.map(item => {
          const data = new Date(item.ano, item.mes - 1); // mês começa do zero em JS
          const mesFormatado = new Intl.DateTimeFormat('pt-BR', { month: 'short' }).format(data);
          const mesAbreviado = mesFormatado.charAt(0).toUpperCase() + mesFormatado.slice(1, 3); // ex: "Mai" -> "Mai"
          const anoFormatado = String(item.ano).slice(2); // pega os dois últimos dígitos do ano
          return `${mesAbreviado}/${anoFormatado}`;
        });
      }
      // Meses
      const meses = gerarLabels(estatisticas);
      // Grárico
      const gerarDados = (label, dados, cor, icone) => {
        const variacoes = dados.map((valor, index) => {
          if (index === 0) return 0;
          const anterior = dados[index - 1];
          return anterior === 0 ? 0 : ((valor - anterior) / anterior) * 100;
        });
        return {
          titulo: label,
          icone: icone,
          data: {
            labels: meses,
            datasets: [{
              label: 'Total',
              backgroundColor: cor,
              data: dados
            }]
          },
          variacoes: variacoes.map(v => Number(v.toFixed(2))),
          options: {
            legend: { display: false },
            responsive: true,
            tooltips: {
              callbacks: {
                // Mostra a variação no tooltip
                label: function (tooltipItem, data) {
                  const valor = tooltipItem.yLabel;
                  const idx = tooltipItem.index;
                  const variacao = variacoes[idx];
                  const variacaoFormatada = idx === 0 ? '' : ` (${variacao > 0 ? '+' : ''}${variacao.toFixed(2)}%)`;
                  return `${data.datasets[0].label}: ${valor}${variacaoFormatada}`;
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        };
      };
      let clientes = [];
      let cnpjs = [];
      let funcionarios = [];
      let usuarios = [];
      let revendedorees = [];
      let revendas = [];
      estatisticas.forEach(item => {
        clientes.push(item.totalClientes);
        cnpjs.push(item.totalCnpjs);
        funcionarios.push(item.totalFuncionarios);
        usuarios.push(item.totalUsuarios);
        revendedorees.push(item.totalRevendedores);
        revendas.push(item.totalRevendas);
      });
      this.graficosTotais = [
        gerarDados('Clientes', clientes, '#42A5F5', 'pi pi-users'),
        gerarDados('CNPJs', cnpjs, '#66BB6A', 'pi pi-briefcase'),
        gerarDados('Funcionários', funcionarios, '#FFA726', 'pi pi-id-card'),
        gerarDados('Usuários', usuarios, '#AB47BC', 'pi pi-user'),
        gerarDados('Revendedores', revendedorees, '#EC407A', 'pi pi-star'),
        gerarDados('Revendas', revendas, '#26A69A', 'pi pi-sitemap')
      ];
    },  
    /**
     * 
     */
    corVariação(valor) {
      if (valor > 0) return 'green';
      if (valor < 0) return 'red';
      return 'gray';
    },
    /**
     * 
     */
    ajustarDatasUltimos12Meses() {
      const dataAtual = new Date();
      // Define a data de fim como hoje
      this.dataFim = dataAtual;
      // Define a data de início com exatamente 11 meses atrás (para incluir o mês atual)
      this.dataInicio = new Date(dataAtual.getFullYear(), dataAtual.getMonth() - 12, 1);      
    },
    /**
     * 
     */
    formatarData(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const dia = String(data.getDate()).padStart(2, '0');
      return `${ano}-${mes}-${dia}`;
    }
  },
  components: {
    Chart
  },
  mounted() {
    this.ajustarDatasUltimos12Meses();
    this.estatisticaAdminService = new EstatisticaAdminService();
    this.busarAcumulado();
  }
};
</script>

<style scoped>
.dashboard {
  background-color: #f4f6f8;
}

.card {
  border-radius: 12px;
  background: #fff;
  padding: 1.5rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.card-body ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.card-body li {
  margin: 0.3rem 0;
}

.linha-total {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.linha-inline {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.badge {
  display: inline-block;
  padding: 0.3rem 0.7rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
}

.badge-green {
  background-color: #4caf50;
}

.badge-gray {
  background-color: #9e9e9e;
}

.badge-red {
  background-color: #f44336;
}

.badge-blue {
  background-color: #2196f3;
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.card-header .icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.grafico-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
}

.variacao {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.9rem;
}

.p-gap-2 {
  gap: 0.5rem;
}

.toolbar-fullwidth {
  width: 100%;
  background: #ffffff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}
</style>